import { useState, useEffect, useCallback } from 'react';
import { apiFetch } from '../lib/api';
import { AUTH_ENABLED } from '../lib/auth';

const LS_KEY = 'defaultProfileId';

export function useUserSettings(getToken: () => Promise<string | null>) {
  // Seed from localStorage for synchronous first-render (avoids flash)
  const [defaultProfileId, setDefaultProfileIdState] = useState<string | null>(
    () => localStorage.getItem(LS_KEY)
  );
  const [settingsLoading, setSettingsLoading] = useState(true);

  useEffect(() => {
    if (!AUTH_ENABLED) { setSettingsLoading(false); return; }
    apiFetch<{ defaultProfileId: string | null }>('/user/settings', {}, getToken)
      .then(data => {
        setDefaultProfileIdState(data.defaultProfileId);
        if (data.defaultProfileId) {
          localStorage.setItem(LS_KEY, data.defaultProfileId);
        } else {
          localStorage.removeItem(LS_KEY);
        }
      })
      .catch(() => {})
      .finally(() => setSettingsLoading(false));
  }, [getToken]);

  const setDefaultProfile = useCallback(async (profileId: string | null) => {
    await apiFetch('/user/settings', {
      method: 'PUT',
      body: JSON.stringify({ defaultProfileId: profileId }),
    }, getToken);
    setDefaultProfileIdState(profileId);
    if (profileId) {
      localStorage.setItem(LS_KEY, profileId);
    } else {
      localStorage.removeItem(LS_KEY);
    }
  }, [getToken]);

  return { defaultProfileId, settingsLoading, setDefaultProfile };
}
